// src/components/Nav.js
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}

export default function Nav() {
  const { user, business, signOut } = useAuth();
  const [bannerOpen, setBannerOpen] = useState(true);
  const location = useLocation();

  function handleNavClick(e, id) {
    e.preventDefault();
    if (location.pathname === '/') {
      scrollTo(id);
    } else {
      window.location.href = '/#' + id;
    }
  }

  return (
    <>
      {/* Top announcement banner */}
      {bannerOpen && (
        <div style={{
          background: 'var(--ring)', color: '#fff',
          padding: '10px 24px', display: 'flex', alignItems: 'center',
          justifyContent: 'center', gap: 12, fontSize: 14, fontWeight: 500,
          position: 'relative'
        }}>
          <span style={{ fontSize: 16 }}>📞</span>
          <span>Try Sophie live right now — call </span>
          <a href="tel:4358003116" style={{ color: '#fff', fontWeight: 700, textDecoration: 'underline' }}>(435) 800-3116</a>
          <span style={{ color: 'rgba(255,255,255,0.7)' }}> · Hear exactly what your customers will experience</span>
          <button
            onClick={() => setBannerOpen(false)}
            style={{ position: 'absolute', right: 16, background: 'none', border: 'none', color: 'rgba(255,255,255,0.7)', cursor: 'pointer', fontSize: 18, lineHeight: 1, padding: 4 }}
            aria-label="Close banner"
          >×</button>
        </div>
      )}

      <nav className="nav" style={{ boxShadow: '0 1px 0 var(--border)' }}>
        <div className="container" style={{ display: 'flex', alignItems: 'center', height: 64, gap: 0 }}>

          {/* Logo — 60px, flush left */}
          <Link to="/" className="nav-logo" style={{ 
            flexShrink: 0, 
            fontSize: 24,
            fontWeight: 700,
            height: 60,
            display: 'flex',
            alignItems: 'center',
            marginRight: 'auto'
          }}>
            Ring<span>Xai</span>
          </Link>

          {/* Center nav links — hidden when user logged in */}
          {!user && (
            <div style={{ display: 'flex', alignItems: 'center', flex: 1, justifyContent: 'center', gap: 4 }}>
              {[{
                label: 'Products',
                items: ['AI Receptionist', 'After Hours Answering', '24/7 Call Answering', 'Bilingual Answering']
              }, {
                label: 'Industries',
                items: ['Cleaning Services', 'HVAC', 'Plumbing', 'Landscaping', 'Salon & Beauty', 'Property Management']
              }].map(menu => (
                <div key={menu.label} style={{ position: 'relative' }} className="nav-menu-group">
                  <button style={{
                    background: 'none', border: 'none', cursor: 'pointer',
                    fontSize: 14, fontWeight: 500, color: 'var(--ink-2)',
                    padding: '8px 14px', borderRadius: 8, fontFamily: 'var(--font-body)',
                    display: 'flex', alignItems: 'center', gap: 4
                  }} className="nav-menu-btn">
                    {menu.label} <span style={{ fontSize: 10, opacity: 0.5 }}>▾</span>
                  </button>
                  <div className="nav-menu-dropdown" style={{
                    position: 'absolute', top: '100%', left: 0, minWidth: 200,
                    background: '#fff', border: '1px solid var(--border)',
                    borderRadius: 12, padding: '8px 0',
                    boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                    zIndex: 200, display: 'none'
                  }}>
                    {menu.items.map(item => (
                      <Link key={item} to="/signup" style={{
                        display: 'block', padding: '9px 16px',
                        fontSize: 14, color: 'var(--ink-2)', textDecoration: 'none', fontWeight: 400
                      }} className="nav-menu-item">{item}</Link>
                    ))}
                  </div>
                </div>
              ))}

              {[
                { label: 'Features', id: 'features' },
                { label: 'Pricing', id: 'pricing' },
                { label: 'Partners', id: 'partners' },
              ].map(item => (
                <a
                  key={item.label}
                  href={`/#${item.id}`}
                  onClick={e => handleNavClick(e, item.id)}
                  style={{
                    fontSize: 14, fontWeight: 500, color: 'var(--ink-2)',
                    textDecoration: 'none', padding: '8px 14px', borderRadius: 8,
                    cursor: 'pointer'
                  }}
                  className="nav-menu-btn"
                >{item.label}</a>
              ))}
            </div>
          )}

          {/* Right: Business name + Sign out — flush right */}
          {user && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0 }}>
              <span style={{ fontSize: 14, fontWeight: 700, color: '#000' }}>
                {business?.['Business Name'] || user.email}
              </span>
              <button className="btn btn-ghost btn-sm" onClick={signOut}>Sign out</button>
            </div>
          )}

          {/* Login/CTA when not logged in */}
          {!user && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
              <Link to="/login" className="btn btn-ghost btn-sm">Login</Link>
              <Link to="/signup" className="btn btn-primary btn-sm" style={{ borderRadius: 999 }}>Free Trial</Link>
            </div>
          )}
        </div>
      </nav>

      <style>{`
        .nav-menu-group:hover .nav-menu-dropdown { display: block !important; }
        .nav-menu-btn:hover { background: var(--surface) !important; color: var(--ring) !important; }
        .nav-menu-item:hover { background: var(--surface); color: var(--ring) !important; }
      `}</style>
    </>
  );
}
